import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type MemberEnterpriseLicensesFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { enterpriseLicenses?: Types.Maybe<Array<(
    { __typename: 'Member_EnterpriseLicense' }
    & Pick<Types.Member_EnterpriseLicense, 'idEnterprise' | 'type'>
  )>> }
);

export const MemberEnterpriseLicensesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MemberEnterpriseLicenses' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enterpriseLicenses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idEnterprise' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMemberEnterpriseLicensesFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MemberEnterpriseLicensesFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseMemberEnterpriseLicensesFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<MemberEnterpriseLicensesFragment>,
    'data'
  > {
  data?: MemberEnterpriseLicensesFragment;
}

export const useMemberEnterpriseLicensesFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMemberEnterpriseLicensesFragmentOptions): UseMemberEnterpriseLicensesFragmentResult => {
  const result = Apollo.useFragment<MemberEnterpriseLicensesFragment>({
    ...options,
    fragment: MemberEnterpriseLicensesFragmentDoc,
    fragmentName: 'MemberEnterpriseLicenses',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as MemberEnterpriseLicensesFragment };
};
